export enum WorkerMessageType {
  Configure = 'Configure',
  Convert   = 'Convert',
}
